exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-height {\n  height: 100%; }\n\n.scroll {\n  overflow: auto; }\n\nh4.ui.header {\n  margin: 0; }\n\n.ui.segments.ttgt-content {\n  margin: 0;\n  border: 0;\n  -webkit-box-shadow: unset;\n          box-shadow: unset;\n  padding: 2rem;\n  height: calc(100% - 4rem); }\n\n.segment-title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row;\n          flex-flow: row;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 4rem; }\n\n.ui.icon.header {\n  margin-top: 4rem;\n  width: 100%; }\n\n.ui.active.centered.inline.loader {\n  margin-top: 5rem; }\n\ndiv.content {\n  padding: 2rem; }\n\ndiv.json {\n  position: absolute;\n  bottom: 2rem;\n  right: 2rem;\n  z-index: 9999999; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/configurations/configurations-detail/configurations-detail.component.scss
// module id = ../../../../../src/app/configurations/configurations-detail/configurations-detail.component.scss
// module chunks = main